import ReportsComponent from "../../../../components/reports/ReportsComponent.vue"

export default [
    {
        path: '/reports',
        name: 'Reports',
        meta: { layout: 'mystagit' },
        component: ReportsComponent,
    },
]